import script from "./Layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout.vue?vue&type=script&lang=ts&setup=true"

import "./Layout.vue?vue&type=style&index=0&id=53ded3cc&lang=less"

const __exports__ = script;

export default __exports__